__turbopack_context__.v({
  "e": "floating-panel-module__os14Ca__e",
  "n": "floating-panel-module__os14Ca__n",
  "ne": "floating-panel-module__os14Ca__ne",
  "nw": "floating-panel-module__os14Ca__nw",
  "panel": "floating-panel-module__os14Ca__panel",
  "resizeHandle": "floating-panel-module__os14Ca__resizeHandle",
  "s": "floating-panel-module__os14Ca__s",
  "se": "floating-panel-module__os14Ca__se",
  "sw": "floating-panel-module__os14Ca__sw",
  "transcript": "floating-panel-module__os14Ca__transcript",
  "w": "floating-panel-module__os14Ca__w",
});
